import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ProductValidation.css';
import Navbar from '../../components/Navbar/Navbar';
import API_URL from '../../config/api';
import * as XLSX from 'xlsx';

export default function ProductValidation() {
	// Upload
	const [file, setFile] = useState(null);
	const [mensagem, setMensagem] = useState('');
	const [loading, setLoading] = useState(false);

	// Filtros vindo da API
	const [produtos, setProdutos] = useState({});
	const [subprodutos, setSubprodutos] = useState([]);
	const [empresas, setEmpresas] = useState([]);
	const [boletins, setBoletins] = useState([]);
	const [status, setStatus] = useState('');

	// Bases completas (para opção TODOS)
	const [subprodutosBase, setSubprodutosBase] = useState([]);
	const [boletinsBase, setBoletinsBase] = useState([]);

	// Filtros selecionados
	const [produto, setProduto] = useState('');
	const [subproduto, setSubProduto] = useState('');
	const [empresa, setEmpresa] = useState('');
	const [boletim, setBoletim] = useState('');
	const [statusList, setStatusList] = useState([]);

	// Tabela
	const [listaResultados, setListaResultados] = useState([]);

	// =============== Carrega Filtros ================
	useEffect(() => {
		carregarFiltros();
	}, []);

	async function carregarFiltros() {
		try {
			const r = await axios.get(`${API_URL}/api/controleSimepar/filtros`);

			setProdutos(r.data.produtos);
			setEmpresas(r.data.empresas || []);

			setSubprodutosBase(r.data.subprodutos || []);
			setBoletinsBase(r.data.boletins || []);
			setStatusList(r.data.status || []);

			setSubprodutos([]);
			setBoletins([]);
		} catch {
			console.log('❌ Erro ao carregar filtros');
		}
	}

	// =============== Filtro produto -> subprodutos ================
	async function carregarSubprodutos(idProduto) {
		setSubprodutos([]);
		setSubProduto('');
		setBoletins([]);
		setBoletim('');

		if (!idProduto) return;

		const r = await axios.get(
			`${API_URL}/api/controleSimepar/subprodutos`,
			{
				params: { idProduto },
			}
		);
		setSubprodutos(r.data);
	}

	// =============== Filtro subproduto -> boletins ================
	async function carregarBoletins(subprodutoSelecionado) {
		setBoletins([]);
		setBoletim('');

		if (!subprodutoSelecionado) return;

		const r = await axios.get(`${API_URL}/api/controleSimepar/boletins`, {
			params: { subproduto: subprodutoSelecionado },
		});
		setBoletins(r.data);
	}

	// =============== Consulta ================
	async function filtrar() {
		const params = {
			idProduto:
				produto !== 'TODOS' && produto !== '' ? Number(produto) : null,
			subproduto: subproduto !== 'TODOS' ? subproduto : null,
			empresa: empresa !== 'TODAS' ? empresa : null,
			boletim: boletim !== 'TODOS' ? boletim : null,
			status: status !== 'TODOS' ? status : null,
		};

		const r = await axios.get(`${API_URL}/api/controleSimepar/buscar`, {
			params,
		});
		setListaResultados(r.data);
	}

	// Upload file
	const handleFileChange = e => setFile(e.target.files[0]);

	async function enviarArquivo() {
		if (!file) return setMensagem('Selecione um arquivo!');

		const data = new FormData();
		data.append('arquivoExcel', file);
		setLoading(true);

		try {
			await axios.post(`${API_URL}/api/controleSimepar/upload`, data);
			setMensagem('✔ Arquivo importado com sucesso!');

			await carregarFiltros();
			setProduto('');
			setSubProduto('');
			setEmpresa('');
			setBoletim('');
			setStatus('');
		} catch {
			setMensagem('❌ Erro ao enviar arquivo.');
		}

		setLoading(false);
	}

	function exportarXLSX() {
		if (!listaResultados || listaResultados.length === 0) return;

		// Monta linhas como objetos (colunas do Excel)
		const rows = listaResultados.map((x, i) => ({
			'#': i + 1,
			Descrição: x.descricao ?? '',
			Empresa: x.empresa ?? '',
			Lote: x.lote ?? '',
			Bloco: x.bloco ?? '',
			'Área Entregue': x.areaEntregue ?? '',
			BE: x.be ?? '',
			Revisão: x.versao ?? '',
			Status: x.status ?? '-',
		}));

		// Gera planilha
		const ws = XLSX.utils.json_to_sheet(rows);

		// (Opcional) largura das colunas para ficar apresentável
		ws['!cols'] = [
			{ wch: 5 }, // #
			{ wch: 45 }, // Descrição
			{ wch: 18 }, // Empresa
			{ wch: 8 }, // Lote
			{ wch: 8 }, // Bloco
			{ wch: 14 }, // Área Entregue
			{ wch: 10 }, // BE
			{ wch: 10 }, // Revisão
			{ wch: 26 }, // Status
		];

		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Resultados');

		// Nome do arquivo com data/hora
		const now = new Date();
		const pad = n => String(n).padStart(2, '0');
		const fileName = `resultado_${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}.xlsx`;

		// Faz download
		XLSX.writeFile(wb, fileName);
	}

	return (
		<>
			<Navbar />

			<div className="pv-wrapper">
				<h1>Validação de Produtos</h1>

				{/* ================= UPLOAD ================= */}
				<div className="box sec-upload">
					<label>
						<b>Importar Planilha:</b>
					</label>

					<div className="upload-row">
						<input
							type="file"
							accept=".xlsx,.xls"
							onChange={handleFileChange}
						/>
						<button onClick={enviarArquivo}>
							{loading ? 'Enviando...' : 'Enviar'}
						</button>
					</div>

					{mensagem && <p className="pv-msg">{mensagem}</p>}
				</div>

				{/* ================= FILTROS ================= */}
				<div className="box sec-filtros">
					<h2>Filtros</h2>

					<div className="filter-grid">
						{/* GRUPO 1 */}
						<div className="filter-group">
							<label>Produto:</label>
							<select
								value={produto}
								onChange={e => {
									const value = e.target.value;
									setProduto(value);

									setSubProduto('');
									setBoletim('');

									if (!value) {
										setSubprodutos([]);
										setBoletins([]);
										return;
									}

									if (value === 'TODOS') {
										setSubprodutos(subprodutosBase);
										setBoletins(boletinsBase);
										return;
									}
									const idNum = Number(value);
									if (!isNaN(idNum)) {
										carregarSubprodutos(idNum);
									}
								}}
							>
								<option value="">Selecione...</option>
								<option value="TODOS" className="opt-todos">
									Todos os produtos
								</option>
								{Object.entries(produtos).map(([id, nome]) => (
									<option key={id} value={id}>
										{nome}
									</option>
								))}
							</select>

							<label>SubProduto:</label>
							<select
								value={subproduto}
								onChange={e => {
									const value = e.target.value;
									setSubProduto(value);
									setBoletim('');

									if (!value) {
										setBoletins([]);
										return;
									}
									if (value === 'TODOS') {
										setBoletins(boletinsBase);
										return;
									}
									carregarBoletins(value);
								}}
							>
								<option value="">Selecione...</option>
								<option value="TODOS" className="opt-todos">
									Todos os subprodutos
								</option>
								{subprodutos.map((s, i) => (
									<option key={i} value={s}>
										{s}
									</option>
								))}
							</select>

							<label>Status:</label>
							<select
								value={status}
								onChange={e => setStatus(e.target.value)}
							>
								<option value="">Selecione...</option>
								<option value="TODOS" className="opt-todos">
									Todos os status
								</option>
								{statusList.map((st, i) => (
									<option key={i} value={st}>
										{st}
									</option>
								))}
							</select>
						</div>

						{/* GRUPO 2 */}
						<div className="filter-group">
							<label>Empresa:</label>
							<select
								value={empresa}
								onChange={e => setEmpresa(e.target.value)}
							>
								<option value="">Selecione...</option>
								<option value="TODAS" className="opt-todos">
									Todas as empresas
								</option>
								{empresas.map((e, i) => (
									<option key={i} value={e}>
										{e}
									</option>
								))}
							</select>

							<label>Boletim:</label>
							<select
								value={boletim}
								onChange={e => setBoletim(e.target.value)}
							>
								<option value="">Selecione...</option>
								<option value="TODOS" className="opt-todos">
									Todos os boletins
								</option>
								{boletins.map((b, i) => (
									<option key={i} value={b}>
										{b}
									</option>
								))}
							</select>
						</div>

						<div className="filter-action">
							<button onClick={filtrar}>Buscar</button>
						</div>
					</div>
				</div>

				{listaResultados.length > 0 && (
					<div className="box sec-lista">
						<div className="sec-lista-header">
							<h2>Lista de Produtos</h2>

							<button
								className="btn-export"
								onClick={exportarXLSX}
								disabled={listaResultados.length === 0}
							>
								Exportar resultado
							</button>
						</div>

						<table>
							<thead>
								<tr>
									<th>#</th>
									<th>Descrição</th>
									<th>Empresa</th>
									<th>Lote</th>
									<th>Bloco</th>
									<th>Área Entregue</th>
									<th>BE</th>
									<th>Revisão</th>
									<th>Status</th>
								</tr>
							</thead>
							<tbody>
								{listaResultados.map((x, i) => (
									<tr key={i}>
										<td className="valor-tabela">
											{i + 1}
										</td>
										<td>{x.descricao}</td>
										<td className="valor-tabela">
											{x.empresa}
										</td>
										<td className="valor-tabela">
											{x.lote}
										</td>
										<td className="valor-tabela">
											{x.bloco}
										</td>
										<td className="valor-tabela">
											{x.areaEntregue}
										</td>
										<td className="valor-tabela">{x.be}</td>
										<td className="valor-tabela">
											{x.versao}
										</td>
										<td className="valor-tabela">
											{x.status ?? '-'}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</>
	);
}
